import { createNames } from "../../utils";
export const getAceTagNames = (id) => createNames(id, 'ACE-TAG', 'SLOT', 'LABEL', 'ICON', '____GAME', '____GAME_ONLY_IMG', 'IMAGE', '____SMALL', '____SUBTLE');
//# sourceMappingURL=ace-tag.get-names.js.map
